<template>
  <modal v-on="$listeners">
    <template v-slot:header>New Note</template>

    <!-- default slot -->
    <div class="flex flex-column min-modal-height">
      <div class="flex-auto flex flex-column justify-end">
        <div class="p2 center">
          <field-note-form :draft="draft" @close="$emit('close')" type="note"/>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import FieldNoteForm from '@/components/FieldNoteForm'

  export default {
    name: 'NewNote',
    props: {
      draft: Object
    },
    components: { FieldNoteForm }
  }
</script>
